import React, {createContext, useContext, useEffect, useState} from 'react'
import {apiConstants, post} from './constants'

// ─── Context ──────────────────────────────────────────────────────────────────
const KycCountsContext = createContext({
  total:          0,
  notStarted:     0,
  awaitingReview: 0,
  docsRejected:   0,
  approved:       0,
})

// ─── Provider — fetches counts once on mount ──────────────────────────────────
export function KycCountsProvider({children}) {
  const [counts, setCounts] = useState({
    total: 0, notStarted: 0, awaitingReview: 0, docsRejected: 0, approved: 0,
  })

  useEffect(() => {
    post(apiConstants.MERCHANT_SEARCH, {
      offset: 0,
      limit: 10000,
      andfilter: [],
      includes: 'id,status,is_deleted,test_merchant,isTestMerchant,kycDetails',
    })
      .then((res) => {
        const active = (res.data?.data || []).filter(
          (m) => m.is_deleted !== '1' && !m.test_merchant && !m.isTestMerchant
        )
        setCounts({
          total:          active.length,
          notStarted:     active.filter((m) => m.status === 'KYC_PENDING').length,
          awaitingReview: active.filter((m) => m.status === 'KYC_UPLOADED').length,
          docsRejected:   active.filter(
            (m) => m.status === 'KYC_REJECTED' || m.kycDetails?.some((d) => d.rejected === true)
          ).length,
          approved:       active.filter((m) => m.status === 'KYC_APPROVED').length,
        })
      })
      .catch(() => {})
  }, [])

  return (
    <KycCountsContext.Provider value={counts}>
      {children}
    </KycCountsContext.Provider>
  )
}

export const useKycCounts = () => useContext(KycCountsContext)
